import React, { useState, useEffect } from 'react';
import Popup from '../popup/Popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';

export default function CreditDebtGuarantee() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    return (
        <>
            <span className="quote-document" onClick={() => togglePopup()}>The Direct Debit Guarantee <FontAwesomeIcon icon={faFileLines} /></span>
            {isPopupOpen && <Popup
                content={<>
                    <h1>The Direct Debit Guarantee</h1>
                    <p>
                        This Guarantee is offered by all banks and building societies that take part in the Direct Debit Scheme. The efficiency and security of the Scheme is monitored and protected by your own Bank or Building Society.
                    </p>
                    <p>
                        If there are any changes to the amount, date or frequency of your Direct Debit, Close Brothers Limited will notify you 7 working days in advance of your account being debited or as otherwise agreed. If you request Close Brothers Limited to collect a payment, confirmation of the amount and date will be given to you at the time of the request.
                    </p>
                    <p>
                        If an error is made in the payment of your Direct Debit, by Close Brothers Limited or your Bank or Building Society, you are guaranteed a full and immediate refund of the amount paid from your bank or building society.
                    </p>
                    <p>
                        If you receive a refund you are not entitled to, you must pay it back when Close Brothers Limited asks you to.
                    </p>
                    <p>
                        You can cancel a Direct Debit at any time by simply contacting your Bank or Building Society. Written confirmation may be required. Please also notify Close Brothers Limited.
                    </p>
                </>}
                handleClose={togglePopup}
            />}
        </>
    )
}